module.exports = __webpack_public_path__ + "img/sso-login-button.622489a9.png";